const TableV2InjectionKey = Symbol("tableV2");
const TABLE_V2_GRID_INJECTION_KEY = "tableV2GridScrollLeft";

export { TABLE_V2_GRID_INJECTION_KEY, TableV2InjectionKey };
//# sourceMappingURL=tokens.mjs.map
